/**
 * calendlyLinkWithParams - Utility that applies UTM query parameters to Calendly URLs. Example:
 * ```jsx
 * clickable({
 *   external_url: calendlyLinkWithParams('https://calendly.com/account/eventName')
 * });
 * ```
 *
 * openCalendly - Utility that opens the Calendly widget for a given account and event name.
 * This method utilizes 'calendlyLinkWithParams' behind the scenes. Example:
 * ```jsx
 * <Button onClick={() => openCalendly('https://calendly.com/account/eventName')}>Chat</Button>
 * ```
 * @packageDocumentation
 */
declare const window: any;

export const CALENDLY_UTM_PARAMS = 'utm_source=product&utm_medium=student_home';
export const ADMISSIONS_CALENDLY_UTM_PARAMS = 'utm_source=product&utm_medium=admissions';

export const calendlyLinkWithParams = (url = '', product = 'home') => {
  // first check for existence of query parameters before applying the appropriate delimiter
  const delimiter = url.split('?').length === 2 ? '&' : '?';

  return `${url}${delimiter}${
    product === 'Admissions' ? ADMISSIONS_CALENDLY_UTM_PARAMS : CALENDLY_UTM_PARAMS
  }`;
};

export const openCalendly = (url = '', product = 'home') => {
  if (window.Calendly) {
    window.Calendly.initPopupWidget({ url: calendlyLinkWithParams(url, product) });
  }
};
